import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, Appointment } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAppointmentMonthProps {
  start: string;
  end: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useAppointmentMonth({
  start,
  end,
  coaches,
  locations,
  eventTypes,
}: IUseAppointmentMonthProps): UseQueryResult<{ data: Array<Appointment> }> {
  const params: UrlParams = { start, end };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(
    ['appointments', 'month', start, end, coaches, eventTypes, locations],
    () => client.get(`appointments/month/?${encodeUrlParams(params)}`),
    {
      enabled: !!start && !!end && end > start,
    },
  );
}

export default useAppointmentMonth;
